import VPurchaseScopeRules from './index.vue';

export default {
  install: (Vue) => Vue.component('VPurchaseScopeRules', VPurchaseScopeRules),
};
